<script setup lang="ts">
import { SellingMethod, AssetType } from '~/apiClient';
import { PlatformBusClass } from '~/types/asset.type';

// COMPOSABLES
const { tt } = useTypedI18n();
const { formatSlpRoute } = useSlpRouteUtils();
const localePath = useLocalePath();

// DATA
const items = [
    {
        to: localePath(formatSlpRoute({ sellingMethod: SellingMethod.DirectSale, assetType: AssetType.Bus, platformClass: PlatformBusClass.City })),
        label: tt(`asset.class.${PlatformBusClass.City}`),
        icon: 'fl:bus-class-one',
    },
    {
        to: localePath(
            formatSlpRoute({ sellingMethod: SellingMethod.DirectSale, assetType: AssetType.Bus, platformClass: PlatformBusClass.Intercity })
        ),
        label: tt(`asset.class.${PlatformBusClass.Intercity}`),
        icon: 'fl:bus-class-two',
    },
    {
        to: localePath(
            formatSlpRoute({ sellingMethod: SellingMethod.DirectSale, assetType: AssetType.Bus, platformClass: PlatformBusClass.Touristic })
        ),
        label: tt(`asset.class.${PlatformBusClass.Touristic}`),
        icon: 'fl:bus-class-three',
    },
    {
        to: localePath(
            formatSlpRoute({ sellingMethod: SellingMethod.DirectSale, assetType: AssetType.Bus, platformClass: PlatformBusClass.SchoolBus })
        ),
        label: tt(`asset.class.${PlatformBusClass.SchoolBus}`),
        icon: 'fl:bus-class-schoolbus',
    },
];
</script>

<template>
    <BlockHero :items="items">
        <template #title>
            <span class="text-5xl md:text-6xl">
                {{ tt('homepage.hero.title') }}
            </span>
        </template>
    </BlockHero>
</template>
